export default __webpack_public_path__ + "static/media/4.8a0c42c3.jpg";